import { removeQueryStringInS3Link } from '@/helpers/s3Helpers';
import { IHomepageTabIntroductionSection } from '../../../../../../../interfaces/enterprise-profile/homepage_tab.interface';
import EnterpriseBaseVideo from '../../../generals/EnterpriseBaseVideo';

const HomepageIntroductionSection = ({
  title,
  content,
  thumbnail,
  videoUrl,
  isUploadVideo,
  image,
  titleColor,
}: IHomepageTabIntroductionSection & { sectionName: string }) => {
  return (
    <div className="flex flex-col items-center gap-[10px] bg-white p-4 lg:flex-row lg:gap-7 lg:p-[85px_24px_59px_63px]">
      <div className="flex flex-1 flex-col justify-center gap-[10px] md:gap-8">
        <h3
          className="text-2xl font-semibold leading-[140%] tracking-[-0.4px] lg:text-[50px]"
          style={{
            color: titleColor,
          }}
        >
          {title}
        </h3>
        <p className="!whitespace-pre-wrap text-sm font-medium leading-7 text-Text/Lightbackground/Secondary lg:text-base">
          {content}
        </p>
      </div>
      <div className="flex max-w-[511px] flex-1 items-center justify-center">
        {isUploadVideo ? (
          <EnterpriseBaseVideo thumbnail={thumbnail} videoUrl={videoUrl} />
        ) : (
          <img
            src={removeQueryStringInS3Link(image)}
            alt="image"
            className="h-full w-full object-cover"
            loading="lazy"
          />
        )}
      </div>
    </div>
  );
};
export default HomepageIntroductionSection;
